// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3jmxX","colMaxWidth":"Table_colMaxWidth__2Eux3"};